<template>
    <v-card-text :class="`text-center ${secondColor}--text pb-0`" v-if="minutesConnected != null && minutesConnected >= 0 && show">
        <div class="text-subtitle-1 font-weight-medium text-no-wrap">
            <template v-if="minutesConnected >= 60">
                {{ dateTime.getHours(minutesConnected) }}<small>h</small>
                {{ String(dateTime.getMinutes(minutesConnected)).padStart(2, "0") }}<small>min</small>
            </template>
            <template v-else>
                {{ minutesConnected }}<small> min</small>
            </template>
        </div>
        <div class="d-flex align-center justify-center text-caption text-no-wrap">
            <v-icon small :color="secondColor" class="mr-1">history</v-icon>
            {{ title }}
        </div>
    </v-card-text>
</template>

<script>
import dateTime from "@/helpers/DateTime";

export default {
    props: {
        minutesConnected: {
            required: true,
        },
        secondColor: {
            required: true,
        },
        title: {
            required: true,
        },
        show: {
            required: true,
        },
    },

    data() {
        return {
            dateTime,
        };
    },
}
</script>
